import { combineEpics } from 'redux-observable';
import { ProfileOptionActionTypes, FetchProfileOptions } from '../actions/ProfileOptionsActions';
import { getFetchProfileOptionsRequestStatus } from '../selectors/RequestStatusSelector';
import ProfileOptionsAPI from '../api/ProfileOptionsAPI';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import requestEntity from './requestEntity';
import RequestEpicDescriptor from './RequestEpicDescriptor';
const fetchProfileOptions = requestEntity(new RequestEpicDescriptor({
  apiFunction: ProfileOptionsAPI.getProfileOptions,
  initiatingActionType: ProfileOptionActionTypes.LOAD_PROFILE_OPTIONS,
  requestStatusSelector: getFetchProfileOptionsRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED],
  requestActions: FetchProfileOptions
}));
export default combineEpics(fetchProfileOptions);